module.exports = __webpack_public_path__ + "img/item_Story_11.c380e9e0.jpeg";